/* eslint-disable jsx-a11y/anchor-is-valid */
import { DeleteOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { billingSelectors } from 'containers/App/selectors';
import { updateOtherDetailSlice } from 'pages/BillingProcess/slices';
import { deleteOther } from 'pages/BillingProcess/thunk';
import { useDispatch, useSelector } from 'react-redux';

type Props = {
  data: any[];
  dataNew: any[];
  setListNew: any;
  statusBill: boolean | undefined;
};

const TableDataUser = ({ data, dataNew, setListNew, statusBill }: Props) => {
  const dispatch = useDispatch();
  const { itemInvoice } = useSelector(billingSelectors);
  const onClick = (index: any, i_id: string, position?: number) => {
    const dataSource = [...dataNew];
    const fIndex = dataNew.findIndex((f) => f.position === position);
    if (fIndex > -1) {
      dataSource.splice(fIndex, 1);
      setListNew(dataSource);
    } else {
      dispatch(updateOtherDetailSlice({ index: index }));
      dispatch(deleteOther({ other_id: i_id, invoice_id: itemInvoice?.i_id ?? '' }));
    }
  };
  const columns: any = [
    {
      title: '概要',
      dataIndex: 'detail_name',
      key: 'name',
      width: '30%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '数量',
      dataIndex: 'other_detail_count',
      key: 'other_detail_count',
      width: '10%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: 'rgba(246, 246, 246, 1)' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '単価',
      dataIndex: 'other_detail_unit_price',
      key: 'other_detail_unit_price',
      width: '20%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '備考',
      dataIndex: 'other_detail_remark',
      key: 'other_detail_remark',
      width: '40%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '',
      key: '1',
      dataIndex: 'button',
      width: '10%',
      align: 'center',
      render(text: string, row: any, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center', borderLeft: '2px solid white' },
            className: 'standardFont',
          },
          children: (
            <div>
              {statusBill ? null : (
                <a
                  style={{
                    backgroundColor: '#F6F6F6',
                    width: '65px',
                    color: 'black',
                    border: 'none',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                  type="button"
                  onClick={() => onClick(index, row?.item_ref?.detail_name?.i_id ?? row.i_id, row.position ?? -1)}
                >
                  削除
                  <DeleteOutlined style={{ marginBottom: '4px' }} />
                </a>
              )}
            </div>
          ),
        };
      },
    },
  ];
  return (
    <div>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        locale={{
          emptyText: <span style={{ color: 'gray' }}>利用なし</span>,
        }}
      />
    </div>
  );
};

export default TableDataUser;
